export function symbolForCurrency(currency: string) {
  if (currency === "USD" || currency === "CAD") {
    return "$";
  }

  throw new Error("Unsupported currency");
}
